<template>
  <div class="upload-img">
    <div class="content-wrapper">
      <div class="upload-img-header" @click="showScale">
        <img-v3 :src="pics[0]" :class="{widthImg:pic_type==1,heightImg:pic_type==2}" />
      </div>
      <div class="upload-img-content">
        <p class="content-title">{{pic_desc.title}}</p>
        <p class="content-p" v-for="(t,idx) in pic_desc.content" :key="idx">{{t}}</p>
      </div>
    </div>
    <scale ref="scaleRef" :img-url="pics[0]"></scale>
  </div>
</template>

<script>
import scale from "./Scale";

export default {
  name: "example",
  components: { scale },
  computed: {
    //1-宽图，2-高图
    pic_type() {
      return this.$route.params.pic_type || 1;
    },
    pics() {
      let p = this.$route.params.pics;
      return p || [];
    },
    pic_desc() {
      let p = this.$route.params.pic_desc;
      return p || {};
    }
  },
  mounted() {},
  data() {
    return {};
  },
  beforeCreate() {
    //一旦进入图片页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  methods: {
    showScale() {
      this.$refs.scaleRef.show();
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2rem;
  .upload-img-header {
    height: 6.12rem;
    background: #282a33;
    overflow: hidden;
    position: relative;
    .widthImg {
      width: 3.84rem;
      height: 5.2rem;
      background-size: 3.84rem 5.2rem;
    }
    .heightImg {
      width: 6rem;
      height: 5.18rem;
      background-size: 6rem 5.18rem;
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.48rem;
      color: #1f2933;
      margin-bottom: 0.24rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      line-height: 1.1;
    }
  }
}
</style>
